import React from 'react';
import { Phone, CheckCircle, Award, Wrench } from 'lucide-react';
export function FarmEquipmentRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6522">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6523">
        <div className="container mx-auto px-4" data-id="element-6524">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6525">
            Farm Equipment Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6526">
            Expert Tractor and Farm Equipment Service
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6527">
        <div className="max-w-6xl mx-auto" data-id="element-6528">
          {/* A Piece of Mind */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6529">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-6530">
              A Piece Of Mind
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-6531">
              <div className="flex items-center justify-center" data-id="element-6532">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fgpsfarm_800big.jpg&site=1986&w=195&h=281&user=1617&opt=w3" alt="Farm equipment GPS" className="rounded-lg shadow-md" style={{
                width: '195px',
                height: '281px'
              }} data-id="element-6533" />
              </div>

              <div data-id="element-6534">
                <p className="text-lg text-gray-700 mb-4" data-id="element-6535">
                  <strong data-id="element-6536">
                    <u data-id="element-6537">At Garrett Auto & Truck Service we understand</u>
                  </strong>{' '}
                  that your farm equipment is one of your most important tools
                  for all of your work needs. Our full-service tractor repair
                  shop and mechanical team will work on your tractor with expert
                  care with affordable, honest prices.
                </p>

                <p className="text-lg text-gray-700 mb-4" data-id="element-6538">
                  We'll bring the best performance possible out of your tractor
                  with our complete tune-ups. The convenience and flexibility of
                  our shop service provides you with the professional tractor
                  care you need with no-hassle repairs.
                </p>

                <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4" data-id="element-6539">
                  <p className="text-lg text-gray-800" data-id="element-6540">
                    <strong data-id="element-6541">
                      Best of all we <em data-id="element-6542">warranty</em> all of our work 100%.
                    </strong>
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4" data-id="element-6543">
                  <p className="text-gray-800" data-id="element-6544">
                    <em data-id="element-6545">
                      <u data-id="element-6546">
                        Our service is backed by our personal pledge of customer
                        satisfaction
                      </u>
                      .
                    </em>
                  </p>
                </div>

                <p className="text-gray-700" data-id="element-6547">
                  We will provide you, our customer, with outstanding
                  professional courtesy and service. And we will stand behind
                  our workmanship.
                </p>
              </div>
            </div>
          </div>

          {/* Onsite Repairs & Maintenance */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-6548">
            <h2 className="text-4xl font-bold flex items-center justify-center" data-id="element-6549">
              <Wrench className="mr-3" size={40} data-id="element-6550" />
              Onsite Repairs & Maintenance
            </h2>
          </div>

          {/* Services Grid */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6551">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-6552">
              {/* Services List */}
              <div data-id="element-6553">
                <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6554">
                  Complete Farm Equipment Services
                </h3>

                <div className="space-y-3" data-id="element-6555">
                  <div className="flex items-start" data-id="element-6556">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6557" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6558">
                      Engine Lights
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6559">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6560" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6561">
                      Diagnostics
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6562">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6563" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6564">
                      Spark Plugs
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6565">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6566" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6567">
                      Hydraulics
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6568">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6569" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6570">
                      Wiring
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6571">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6572" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6573">
                      Clutches
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6574">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6575" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6576">
                      Tractor/Farm Equipment (Trans)
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6577">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6578" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6579">
                      Preventative (Maint)
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6580">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6581" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6582">
                      Air-Conditioning
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6583">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6584" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6585">
                      Water Pumps
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6586">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6587" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6588">
                      Brake Service
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6589">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6590" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6591">
                      Major and Minor Repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6592">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6593" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6594">
                      Attachments for Behind Tractor
                    </span>
                  </div>
                </div>
              </div>

              {/* Tractor Image */}
              <div className="flex items-center justify-center" data-id="element-6595">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Ftractor2.jpg&site=1986&w=467&h=355&user=1617&opt=w3" alt="Tractor repair" className="rounded-lg shadow-md w-full h-auto" style={{
                maxWidth: '467px',
                maxHeight: '355px'
              }} data-id="element-6596" />
              </div>
            </div>
          </div>

          {/* Our Commitment */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6597">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6598">
              Our Commitment to You
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-6599">
              <div className="text-center" data-id="element-6600">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6601">
                  <Award className="text-blue-600" size={32} data-id="element-6602" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6603">
                  100% Warranty
                </h3>
                <p className="text-gray-700" data-id="element-6604">
                  All of our work is backed by our complete warranty
                </p>
              </div>

              <div className="text-center" data-id="element-6605">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6606">
                  <CheckCircle className="text-green-600" size={32} data-id="element-6607" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6608">
                  Customer Satisfaction
                </h3>
                <p className="text-gray-700" data-id="element-6609">
                  Personal pledge of outstanding service and courtesy
                </p>
              </div>

              <div className="text-center" data-id="element-6610">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6611">
                  <Wrench className="text-purple-600" size={32} data-id="element-6612" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6613">
                  Expert Care
                </h3>
                <p className="text-gray-700" data-id="element-6614">
                  Affordable, honest prices with professional workmanship
                </p>
              </div>
            </div>
          </div>

          {/* Service Categories */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6615">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6616">
              What We Service
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-6617">
              <div className="bg-green-50 rounded-lg p-6" data-id="element-6618">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6619">
                  Engine & Performance
                </h3>
                <ul className="space-y-2" data-id="element-6620">
                  <li className="flex items-start" data-id="element-6621">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6622" />
                    <span className="text-gray-700" data-id="element-6623">
                      Engine diagnostics and lights
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6624">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6625" />
                    <span className="text-gray-700" data-id="element-6626">
                      Spark plugs and tune-ups
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6627">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6628" />
                    <span className="text-gray-700" data-id="element-6629">
                      Water pumps and cooling systems
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6630">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6631" />
                    <span className="text-gray-700" data-id="element-6632">
                      Air-conditioning service
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-6633">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6634">
                  Mechanical Systems
                </h3>
                <ul className="space-y-2" data-id="element-6635">
                  <li className="flex items-start" data-id="element-6636">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6637" />
                    <span className="text-gray-700" data-id="element-6638">Hydraulic systems</span>
                  </li>
                  <li className="flex items-start" data-id="element-6639">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6640" />
                    <span className="text-gray-700" data-id="element-6641">
                      Clutches and transmissions
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6642">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6643" />
                    <span className="text-gray-700" data-id="element-6644">
                      Brake service and repair
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6645">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6646" />
                    <span className="text-gray-700" data-id="element-6647">
                      Electrical wiring systems
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-6648">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6649">
                  Maintenance & Repair
                </h3>
                <ul className="space-y-2" data-id="element-6650">
                  <li className="flex items-start" data-id="element-6651">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6652" />
                    <span className="text-gray-700" data-id="element-6653">
                      Preventative maintenance programs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6654">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6655" />
                    <span className="text-gray-700" data-id="element-6656">
                      Major mechanical repairs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6657">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6658" />
                    <span className="text-gray-700" data-id="element-6659">
                      Minor mechanical repairs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6660">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6661" />
                    <span className="text-gray-700" data-id="element-6662">Complete diagnostics</span>
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-6663">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6664">
                  Equipment & Attachments
                </h3>
                <ul className="space-y-2" data-id="element-6665">
                  <li className="flex items-start" data-id="element-6666">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6667" />
                    <span className="text-gray-700" data-id="element-6668">
                      Tractor attachments service
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6669">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6670" />
                    <span className="text-gray-700" data-id="element-6671">
                      Farm equipment transmissions
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6672">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6673" />
                    <span className="text-gray-700" data-id="element-6674">
                      Onsite repair services
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6675">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6676" />
                    <span className="text-gray-700" data-id="element-6677">
                      No-hassle shop service
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6678">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6679">
              Expert Farm Equipment & Tractor Repair
            </h2>
            <p className="text-xl mb-6" data-id="element-6680">
              Affordable, honest service with 100% warranty on all work
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6681">
              <Phone className="mr-3" size={24} data-id="element-6682" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6683">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}